// @generated by protoc-gen-es v2.11.0 with parameter "target=ts,json_types=true"
// @generated from file container_group.proto (package raccoonai, syntax proto2)
/* eslint-disable */

import type { GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import type { Contact, ContactJson } from "./contact_pb";
import { file_contact } from "./contact_pb";
import type { Contract, ContractJson } from "./contract_pb";
import { file_contract } from "./contract_pb";
import type { ContainerTypeStatus, ContainerTypeStatusJson, JobType, JobTypeJson } from "./enums_pb";
import { file_enums } from "./enums_pb";
import type { IdList, IdListJson, ListInfo, ListInfoJson } from "./general_pb";
import { file_general } from "./general_pb";
import type { StructJson, Timestamp, TimestampJson } from "@bufbuild/protobuf/wkt";
import { file_google_protobuf_struct, file_google_protobuf_timestamp } from "@bufbuild/protobuf/wkt";
import type { Organization, OrganizationJson } from "./organization_pb";
import { file_organization } from "./organization_pb";
import type { JsonObject, Message } from "@bufbuild/protobuf";

/**
 * Describes the file container_group.proto.
 */
export const file_container_group: GenFile = /*@__PURE__*/
  fileDesc("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", [file_contact, file_contract, file_enums, file_general, file_google_protobuf_struct, file_google_protobuf_timestamp, file_organization]);

/**
 * *****************************************************
 * CONTAINER TYPE
 * *****************************************************
 *
 * @generated from message raccoonai.ContainerType
 */
export type ContainerType = Message<"raccoonai.ContainerType"> & {
  /**
   * @generated from field: required uint64 id = 1;
   */
  id: bigint;

  /**
   * @generated from field: required string name = 2 [json_name = "type_name"];
   */
  name: string;

  /**
   * @generated from field: required uint64 owner_organization_id = 3 [json_name = "owner_organization_id"];
   */
  ownerOrganizationId: bigint;

  /**
   * @generated from field: required float volume = 4;
   */
  volume: number;

  /**
   * @generated from field: optional float weight_kg = 5 [json_name = "weight_kg"];
   */
  weightKg: number;

  /**
   * The company that made the type. Set only where the caller preloads it (ListContainerTypes, whose list spans the
   * holding; GovDashService.GovListContainerTypes).
   *
   * @generated from field: optional raccoonai.Organization owner_organization = 6 [json_name = "owner_organization"];
   */
  ownerOrganization?: Organization;

  /**
   * @generated from field: optional raccoonai.ContainerTypeStatus status = 7;
   */
  status: ContainerTypeStatus;

  /**
   * @generated from field: optional google.protobuf.Timestamp created_at = 101 [json_name = "created_at"];
   */
  createdAt?: Timestamp;

  /**
   * @generated from field: optional google.protobuf.Timestamp updated_at = 102 [json_name = "updated_at"];
   */
  updatedAt?: Timestamp;
};

/**
 * *****************************************************
 * CONTAINER TYPE
 * *****************************************************
 *
 * @generated from message raccoonai.ContainerType
 */
export type ContainerTypeJson = {
  /**
   * @generated from field: required uint64 id = 1;
   */
  id?: string;

  /**
   * @generated from field: required string name = 2 [json_name = "type_name"];
   */
  type_name?: string;

  /**
   * @generated from field: required uint64 owner_organization_id = 3 [json_name = "owner_organization_id"];
   */
  owner_organization_id?: string;

  /**
   * @generated from field: required float volume = 4;
   */
  volume?: number | "NaN" | "Infinity" | "-Infinity";

  /**
   * @generated from field: optional float weight_kg = 5 [json_name = "weight_kg"];
   */
  weight_kg?: number | "NaN" | "Infinity" | "-Infinity";

  /**
   * The company that made the type. Set only where the caller preloads it (ListContainerTypes, whose list spans the
   * holding; GovDashService.GovListContainerTypes).
   *
   * @generated from field: optional raccoonai.Organization owner_organization = 6 [json_name = "owner_organization"];
   */
  owner_organization?: OrganizationJson;

  /**
   * @generated from field: optional raccoonai.ContainerTypeStatus status = 7;
   */
  status?: ContainerTypeStatusJson;

  /**
   * @generated from field: optional google.protobuf.Timestamp created_at = 101 [json_name = "created_at"];
   */
  created_at?: TimestampJson;

  /**
   * @generated from field: optional google.protobuf.Timestamp updated_at = 102 [json_name = "updated_at"];
   */
  updated_at?: TimestampJson;
};

/**
 * Describes the message raccoonai.ContainerType.
 * Use `create(ContainerTypeSchema)` to create a new message.
 */
export const ContainerTypeSchema: GenMessage<ContainerType, {jsonType: ContainerTypeJson}> = /*@__PURE__*/
  messageDesc(file_container_group, 0);

/**
 * @generated from message raccoonai.ContainerTypeCreate
 */
export type ContainerTypeCreate = Message<"raccoonai.ContainerTypeCreate"> & {
  /**
   * @generated from field: required string name = 1;
   */
  name: string;

  /**
   * @generated from field: required uint64 owner_organization_id = 2 [json_name = "owner_organization_id"];
   */
  ownerOrganizationId: bigint;

  /**
   * @generated from field: required float volume = 3;
   */
  volume: number;

  /**
   * @generated from field: required float weight_kg = 4 [json_name = "weight_kg"];
   */
  weightKg: number;
};

/**
 * @generated from message raccoonai.ContainerTypeCreate
 */
export type ContainerTypeCreateJson = {
  /**
   * @generated from field: required string name = 1;
   */
  name?: string;

  /**
   * @generated from field: required uint64 owner_organization_id = 2 [json_name = "owner_organization_id"];
   */
  owner_organization_id?: string;

  /**
   * @generated from field: required float volume = 3;
   */
  volume?: number | "NaN" | "Infinity" | "-Infinity";

  /**
   * @generated from field: required float weight_kg = 4 [json_name = "weight_kg"];
   */
  weight_kg?: number | "NaN" | "Infinity" | "-Infinity";
};

/**
 * Describes the message raccoonai.ContainerTypeCreate.
 * Use `create(ContainerTypeCreateSchema)` to create a new message.
 */
export const ContainerTypeCreateSchema: GenMessage<ContainerTypeCreate, {jsonType: ContainerTypeCreateJson}> = /*@__PURE__*/
  messageDesc(file_container_group, 1);

/**
 * @generated from message raccoonai.ContainerTypeUpdate
 */
export type ContainerTypeUpdate = Message<"raccoonai.ContainerTypeUpdate"> & {
  /**
   * @generated from field: required uint64 id = 1;
   */
  id: bigint;

  /**
   * to be required
   *
   * @generated from field: optional uint64 owner_organization_id = 2 [json_name = "owner_organization_id"];
   */
  ownerOrganizationId: bigint;

  /**
   * @generated from field: optional string name = 3;
   */
  name: string;

  /**
   * @generated from field: optional float volume = 4;
   */
  volume: number;

  /**
   * @generated from field: optional float weight_kg = 5 [json_name = "weight_kg"];
   */
  weightKg: number;

  /**
   * @generated from field: optional raccoonai.ContainerTypeStatus status = 6;
   */
  status: ContainerTypeStatus;
};

/**
 * @generated from message raccoonai.ContainerTypeUpdate
 */
export type ContainerTypeUpdateJson = {
  /**
   * @generated from field: required uint64 id = 1;
   */
  id?: string;

  /**
   * to be required
   *
   * @generated from field: optional uint64 owner_organization_id = 2 [json_name = "owner_organization_id"];
   */
  owner_organization_id?: string;

  /**
   * @generated from field: optional string name = 3;
   */
  name?: string;

  /**
   * @generated from field: optional float volume = 4;
   */
  volume?: number | "NaN" | "Infinity" | "-Infinity";

  /**
   * @generated from field: optional float weight_kg = 5 [json_name = "weight_kg"];
   */
  weight_kg?: number | "NaN" | "Infinity" | "-Infinity";

  /**
   * @generated from field: optional raccoonai.ContainerTypeStatus status = 6;
   */
  status?: ContainerTypeStatusJson;
};

/**
 * Describes the message raccoonai.ContainerTypeUpdate.
 * Use `create(ContainerTypeUpdateSchema)` to create a new message.
 */
export const ContainerTypeUpdateSchema: GenMessage<ContainerTypeUpdate, {jsonType: ContainerTypeUpdateJson}> = /*@__PURE__*/
  messageDesc(file_container_group, 2);

/**
 * @generated from message raccoonai.ContainerTypeList
 */
export type ContainerTypeList = Message<"raccoonai.ContainerTypeList"> & {
  /**
   * @generated from field: repeated raccoonai.ContainerType container_types = 1 [json_name = "container_types"];
   */
  containerTypes: ContainerType[];

  /**
   * @generated from field: optional raccoonai.ListInfo list_info = 2 [json_name = "list_info"];
   */
  listInfo?: ListInfo;
};

/**
 * @generated from message raccoonai.ContainerTypeList
 */
export type ContainerTypeListJson = {
  /**
   * @generated from field: repeated raccoonai.ContainerType container_types = 1 [json_name = "container_types"];
   */
  container_types?: ContainerTypeJson[];

  /**
   * @generated from field: optional raccoonai.ListInfo list_info = 2 [json_name = "list_info"];
   */
  list_info?: ListInfoJson;
};

/**
 * Describes the message raccoonai.ContainerTypeList.
 * Use `create(ContainerTypeListSchema)` to create a new message.
 */
export const ContainerTypeListSchema: GenMessage<ContainerTypeList, {jsonType: ContainerTypeListJson}> = /*@__PURE__*/
  messageDesc(file_container_group, 3);

/**
 * *****************************************************
 * CONTAINER GROUP
 * *****************************************************
 *
 * @generated from message raccoonai.ContainerGroup
 */
export type ContainerGroup = Message<"raccoonai.ContainerGroup"> & {
  /**
   * @generated from field: required uint64 id = 1;
   */
  id: bigint;

  /**
   * @generated from field: required uint64 owner_organization_id = 2 [json_name = "owner_organization_id"];
   */
  ownerOrganizationId: bigint;

  /**
   * @generated from field: optional raccoonai.Organization owner_organization = 3 [json_name = "owner_organization"];
   */
  ownerOrganization?: Organization;

  /**
   * @generated from field: required raccoonai.ContainerType container_type = 4 [json_name = "container_type"];
   */
  containerType?: ContainerType;

  /**
   * @generated from field: required uint32 number_of_containers = 5 [json_name = "number_of_containers"];
   */
  numberOfContainers: number;

  /**
   * @generated from field: required uint64 pickup_location_id = 6 [json_name = "pickup_location_id"];
   */
  pickupLocationId: bigint;

  /**
   * @generated from field: optional google.protobuf.Struct service_schedule_by_job_type = 7 [json_name = "service_schedule_by_job_type"];
   */
  serviceScheduleByJobType?: JsonObject;

  /**
   * trunk check
   *
   * @generated from field: optional uint64 contract_id = 8 [json_name = "contract_id"];
   */
  contractId: bigint;

  /**
   * trunk check
   *
   * @generated from field: optional raccoonai.Contract contract = 9;
   */
  contract?: Contract;

  /**
   * @generated from field: optional string pickup_location_name = 10 [json_name = "pickup_location_name"];
   */
  pickupLocationName: string;

  /**
   * @generated from field: optional uint64 primary_contact_id = 11 [json_name = "primary_contact_id"];
   */
  primaryContactId: bigint;

  /**
   * @generated from field: optional raccoonai.Contact primary_contact = 12 [json_name = "primary_contact"];
   */
  primaryContact?: Contact;

  /**
   * Responsible zone: the service providers that serve the group, in order; the first is the default for a new job.
   *
   * @generated from field: repeated uint64 service_provider_ids = 13 [json_name = "service_provider_ids"];
   */
  serviceProviderIds: bigint[];

  /**
   * @generated from field: repeated raccoonai.Organization service_providers = 14 [json_name = "service_providers"];
   */
  serviceProviders: Organization[];

  /**
   * filled by GetContainerGroupById only
   *
   * @generated from field: repeated raccoonai.ContainerGroupSchedule schedules = 15;
   */
  schedules: ContainerGroupSchedule[];

  /**
   * @generated from field: repeated raccoonai.ContainerGroupRouteGroup route_groups = 16 [json_name = "route_groups"];
   */
  routeGroups: ContainerGroupRouteGroup[];

  /**
   * @generated from field: optional google.protobuf.Timestamp created_at = 101 [json_name = "created_at"];
   */
  createdAt?: Timestamp;

  /**
   * @generated from field: optional google.protobuf.Timestamp updated_at = 102 [json_name = "updated_at"];
   */
  updatedAt?: Timestamp;
};

/**
 * *****************************************************
 * CONTAINER GROUP
 * *****************************************************
 *
 * @generated from message raccoonai.ContainerGroup
 */
export type ContainerGroupJson = {
  /**
   * @generated from field: required uint64 id = 1;
   */
  id?: string;

  /**
   * @generated from field: required uint64 owner_organization_id = 2 [json_name = "owner_organization_id"];
   */
  owner_organization_id?: string;

  /**
   * @generated from field: optional raccoonai.Organization owner_organization = 3 [json_name = "owner_organization"];
   */
  owner_organization?: OrganizationJson;

  /**
   * @generated from field: required raccoonai.ContainerType container_type = 4 [json_name = "container_type"];
   */
  container_type?: ContainerTypeJson;

  /**
   * @generated from field: required uint32 number_of_containers = 5 [json_name = "number_of_containers"];
   */
  number_of_containers?: number;

  /**
   * @generated from field: required uint64 pickup_location_id = 6 [json_name = "pickup_location_id"];
   */
  pickup_location_id?: string;

  /**
   * @generated from field: optional google.protobuf.Struct service_schedule_by_job_type = 7 [json_name = "service_schedule_by_job_type"];
   */
  service_schedule_by_job_type?: StructJson;

  /**
   * trunk check
   *
   * @generated from field: optional uint64 contract_id = 8 [json_name = "contract_id"];
   */
  contract_id?: string;

  /**
   * trunk check
   *
   * @generated from field: optional raccoonai.Contract contract = 9;
   */
  contract?: ContractJson;

  /**
   * @generated from field: optional string pickup_location_name = 10 [json_name = "pickup_location_name"];
   */
  pickup_location_name?: string;

  /**
   * @generated from field: optional uint64 primary_contact_id = 11 [json_name = "primary_contact_id"];
   */
  primary_contact_id?: string;

  /**
   * @generated from field: optional raccoonai.Contact primary_contact = 12 [json_name = "primary_contact"];
   */
  primary_contact?: ContactJson;

  /**
   * Responsible zone: the service providers that serve the group, in order; the first is the default for a new job.
   *
   * @generated from field: repeated uint64 service_provider_ids = 13 [json_name = "service_provider_ids"];
   */
  service_provider_ids?: string[];

  /**
   * @generated from field: repeated raccoonai.Organization service_providers = 14 [json_name = "service_providers"];
   */
  service_providers?: OrganizationJson[];

  /**
   * filled by GetContainerGroupById only
   *
   * @generated from field: repeated raccoonai.ContainerGroupSchedule schedules = 15;
   */
  schedules?: ContainerGroupScheduleJson[];

  /**
   * @generated from field: repeated raccoonai.ContainerGroupRouteGroup route_groups = 16 [json_name = "route_groups"];
   */
  route_groups?: ContainerGroupRouteGroupJson[];

  /**
   * @generated from field: optional google.protobuf.Timestamp created_at = 101 [json_name = "created_at"];
   */
  created_at?: TimestampJson;

  /**
   * @generated from field: optional google.protobuf.Timestamp updated_at = 102 [json_name = "updated_at"];
   */
  updated_at?: TimestampJson;
};

/**
 * Describes the message raccoonai.ContainerGroup.
 * Use `create(ContainerGroupSchema)` to create a new message.
 */
export const ContainerGroupSchema: GenMessage<ContainerGroup, {jsonType: ContainerGroupJson}> = /*@__PURE__*/
  messageDesc(file_container_group, 4);

/**
 * A route group the container group is bound to for one job type.
 *
 * @generated from message raccoonai.ContainerGroupRouteGroup
 */
export type ContainerGroupRouteGroup = Message<"raccoonai.ContainerGroupRouteGroup"> & {
  /**
   * @generated from field: required uint64 pickup_location_group_id = 1 [json_name = "pickup_location_group_id"];
   */
  pickupLocationGroupId: bigint;

  /**
   * @generated from field: required string name = 2;
   */
  name: string;

  /**
   * @generated from field: required raccoonai.JobType job_type = 3 [json_name = "job_type"];
   */
  jobType: JobType;

  /**
   * @generated from field: required uint64 owner_organization_id = 4 [json_name = "owner_organization_id"];
   */
  ownerOrganizationId: bigint;
};

/**
 * A route group the container group is bound to for one job type.
 *
 * @generated from message raccoonai.ContainerGroupRouteGroup
 */
export type ContainerGroupRouteGroupJson = {
  /**
   * @generated from field: required uint64 pickup_location_group_id = 1 [json_name = "pickup_location_group_id"];
   */
  pickup_location_group_id?: string;

  /**
   * @generated from field: required string name = 2;
   */
  name?: string;

  /**
   * @generated from field: required raccoonai.JobType job_type = 3 [json_name = "job_type"];
   */
  job_type?: JobTypeJson;

  /**
   * @generated from field: required uint64 owner_organization_id = 4 [json_name = "owner_organization_id"];
   */
  owner_organization_id?: string;
};

/**
 * Describes the message raccoonai.ContainerGroupRouteGroup.
 * Use `create(ContainerGroupRouteGroupSchema)` to create a new message.
 */
export const ContainerGroupRouteGroupSchema: GenMessage<ContainerGroupRouteGroup, {jsonType: ContainerGroupRouteGroupJson}> = /*@__PURE__*/
  messageDesc(file_container_group, 5);

/**
 * @generated from message raccoonai.ContainerGroupCreate
 */
export type ContainerGroupCreate = Message<"raccoonai.ContainerGroupCreate"> & {
  /**
   * @generated from field: required uint64 owner_organization_id = 1 [json_name = "owner_organization_id"];
   */
  ownerOrganizationId: bigint;

  /**
   * @generated from field: required uint64 container_type_id = 2 [json_name = "container_type_id"];
   */
  containerTypeId: bigint;

  /**
   * @generated from field: required uint32 number_of_containers = 3 [json_name = "number_of_containers"];
   */
  numberOfContainers: number;

  /**
   * @generated from field: required uint64 pickup_location_id = 4 [json_name = "pickup_location_id"];
   */
  pickupLocationId: bigint;

  /**
   * @generated from field: optional google.protobuf.Struct service_schedule_by_job_type = 5 [json_name = "service_schedule_by_job_type"];
   */
  serviceScheduleByJobType?: JsonObject;

  /**
   * @generated from field: optional uint64 contract_id = 7 [json_name = "contract_id"];
   */
  contractId: bigint;

  /**
   * @generated from field: optional uint64 primary_contact_id = 8 [json_name = "primary_contact_id"];
   */
  primaryContactId: bigint;

  /**
   * @generated from field: repeated uint64 service_provider_ids = 9 [json_name = "service_provider_ids"];
   */
  serviceProviderIds: bigint[];
};

/**
 * @generated from message raccoonai.ContainerGroupCreate
 */
export type ContainerGroupCreateJson = {
  /**
   * @generated from field: required uint64 owner_organization_id = 1 [json_name = "owner_organization_id"];
   */
  owner_organization_id?: string;

  /**
   * @generated from field: required uint64 container_type_id = 2 [json_name = "container_type_id"];
   */
  container_type_id?: string;

  /**
   * @generated from field: required uint32 number_of_containers = 3 [json_name = "number_of_containers"];
   */
  number_of_containers?: number;

  /**
   * @generated from field: required uint64 pickup_location_id = 4 [json_name = "pickup_location_id"];
   */
  pickup_location_id?: string;

  /**
   * @generated from field: optional google.protobuf.Struct service_schedule_by_job_type = 5 [json_name = "service_schedule_by_job_type"];
   */
  service_schedule_by_job_type?: StructJson;

  /**
   * @generated from field: optional uint64 contract_id = 7 [json_name = "contract_id"];
   */
  contract_id?: string;

  /**
   * @generated from field: optional uint64 primary_contact_id = 8 [json_name = "primary_contact_id"];
   */
  primary_contact_id?: string;

  /**
   * @generated from field: repeated uint64 service_provider_ids = 9 [json_name = "service_provider_ids"];
   */
  service_provider_ids?: string[];
};

/**
 * Describes the message raccoonai.ContainerGroupCreate.
 * Use `create(ContainerGroupCreateSchema)` to create a new message.
 */
export const ContainerGroupCreateSchema: GenMessage<ContainerGroupCreate, {jsonType: ContainerGroupCreateJson}> = /*@__PURE__*/
  messageDesc(file_container_group, 6);

/**
 * @generated from message raccoonai.ContainerGroupUpdate
 */
export type ContainerGroupUpdate = Message<"raccoonai.ContainerGroupUpdate"> & {
  /**
   * @generated from field: required uint64 id = 1;
   */
  id: bigint;

  /**
   * to be required
   *
   * @generated from field: optional uint64 owner_organization_id = 2 [json_name = "owner_organization_id"];
   */
  ownerOrganizationId: bigint;

  /**
   * @generated from field: optional uint64 container_type_id = 3 [json_name = "container_type_id"];
   */
  containerTypeId: bigint;

  /**
   * @generated from field: optional uint32 number_of_containers = 4 [json_name = "number_of_containers"];
   */
  numberOfContainers: number;

  /**
   * @generated from field: optional uint64 pickup_location_id = 5 [json_name = "pickup_location_id"];
   */
  pickupLocationId: bigint;

  /**
   * @generated from field: optional google.protobuf.Struct service_schedule_by_job_type = 6 [json_name = "service_schedule_by_job_type"];
   */
  serviceScheduleByJobType?: JsonObject;

  /**
   * @generated from field: optional uint64 contract_id = 7 [json_name = "contract_id"];
   */
  contractId: bigint;

  /**
   * @generated from field: optional uint64 primary_contact_id = 8 [json_name = "primary_contact_id"];
   */
  primaryContactId: bigint;

  /**
   * @generated from field: optional raccoonai.IdList service_provider_ids = 9 [json_name = "service_provider_ids"];
   */
  serviceProviderIds?: IdList;
};

/**
 * @generated from message raccoonai.ContainerGroupUpdate
 */
export type ContainerGroupUpdateJson = {
  /**
   * @generated from field: required uint64 id = 1;
   */
  id?: string;

  /**
   * to be required
   *
   * @generated from field: optional uint64 owner_organization_id = 2 [json_name = "owner_organization_id"];
   */
  owner_organization_id?: string;

  /**
   * @generated from field: optional uint64 container_type_id = 3 [json_name = "container_type_id"];
   */
  container_type_id?: string;

  /**
   * @generated from field: optional uint32 number_of_containers = 4 [json_name = "number_of_containers"];
   */
  number_of_containers?: number;

  /**
   * @generated from field: optional uint64 pickup_location_id = 5 [json_name = "pickup_location_id"];
   */
  pickup_location_id?: string;

  /**
   * @generated from field: optional google.protobuf.Struct service_schedule_by_job_type = 6 [json_name = "service_schedule_by_job_type"];
   */
  service_schedule_by_job_type?: StructJson;

  /**
   * @generated from field: optional uint64 contract_id = 7 [json_name = "contract_id"];
   */
  contract_id?: string;

  /**
   * @generated from field: optional uint64 primary_contact_id = 8 [json_name = "primary_contact_id"];
   */
  primary_contact_id?: string;

  /**
   * @generated from field: optional raccoonai.IdList service_provider_ids = 9 [json_name = "service_provider_ids"];
   */
  service_provider_ids?: IdListJson;
};

/**
 * Describes the message raccoonai.ContainerGroupUpdate.
 * Use `create(ContainerGroupUpdateSchema)` to create a new message.
 */
export const ContainerGroupUpdateSchema: GenMessage<ContainerGroupUpdate, {jsonType: ContainerGroupUpdateJson}> = /*@__PURE__*/
  messageDesc(file_container_group, 7);

/**
 * @generated from message raccoonai.ContainerGroupList
 */
export type ContainerGroupList = Message<"raccoonai.ContainerGroupList"> & {
  /**
   * @generated from field: repeated raccoonai.ContainerGroup container_groups = 1 [json_name = "container_groups"];
   */
  containerGroups: ContainerGroup[];

  /**
   * @generated from field: optional raccoonai.ListInfo list_info = 2 [json_name = "list_info"];
   */
  listInfo?: ListInfo;
};

/**
 * @generated from message raccoonai.ContainerGroupList
 */
export type ContainerGroupListJson = {
  /**
   * @generated from field: repeated raccoonai.ContainerGroup container_groups = 1 [json_name = "container_groups"];
   */
  container_groups?: ContainerGroupJson[];

  /**
   * @generated from field: optional raccoonai.ListInfo list_info = 2 [json_name = "list_info"];
   */
  list_info?: ListInfoJson;
};

/**
 * Describes the message raccoonai.ContainerGroupList.
 * Use `create(ContainerGroupListSchema)` to create a new message.
 */
export const ContainerGroupListSchema: GenMessage<ContainerGroupList, {jsonType: ContainerGroupListJson}> = /*@__PURE__*/
  messageDesc(file_container_group, 8);

/**
 * *****************************************************
 * CONTAINER GROUP SCHEDULE
 * *****************************************************
 *
 * @generated from message raccoonai.ScheduleWindow
 */
export type ScheduleWindow = Message<"raccoonai.ScheduleWindow"> & {
  /**
   * "HH:MM"
   *
   * @generated from field: required string from = 1;
   */
  from: string;

  /**
   * @generated from field: required string to = 2;
   */
  to: string;
};

/**
 * *****************************************************
 * CONTAINER GROUP SCHEDULE
 * *****************************************************
 *
 * @generated from message raccoonai.ScheduleWindow
 */
export type ScheduleWindowJson = {
  /**
   * "HH:MM"
   *
   * @generated from field: required string from = 1;
   */
  from?: string;

  /**
   * @generated from field: required string to = 2;
   */
  to?: string;
};

/**
 * Describes the message raccoonai.ScheduleWindow.
 * Use `create(ScheduleWindowSchema)` to create a new message.
 */
export const ScheduleWindowSchema: GenMessage<ScheduleWindow, {jsonType: ScheduleWindowJson}> = /*@__PURE__*/
  messageDesc(file_container_group, 9);

/**
 * @generated from message raccoonai.WeeklyRule
 */
export type WeeklyRule = Message<"raccoonai.WeeklyRule"> & {
  /**
   * 0 = Sunday … 6 = Saturday
   *
   * @generated from field: required uint32 dow = 1;
   */
  dow: number;

  /**
   * weeks of the month 1-5 (days 7N-6..7N); empty = every week
   *
   * @generated from field: repeated uint32 weeks = 2;
   */
  weeks: number[];

  /**
   * @generated from field: repeated raccoonai.ScheduleWindow windows = 3;
   */
  windows: ScheduleWindow[];
};

/**
 * @generated from message raccoonai.WeeklyRule
 */
export type WeeklyRuleJson = {
  /**
   * 0 = Sunday … 6 = Saturday
   *
   * @generated from field: required uint32 dow = 1;
   */
  dow?: number;

  /**
   * weeks of the month 1-5 (days 7N-6..7N); empty = every week
   *
   * @generated from field: repeated uint32 weeks = 2;
   */
  weeks?: number[];

  /**
   * @generated from field: repeated raccoonai.ScheduleWindow windows = 3;
   */
  windows?: ScheduleWindowJson[];
};

/**
 * Describes the message raccoonai.WeeklyRule.
 * Use `create(WeeklyRuleSchema)` to create a new message.
 */
export const WeeklyRuleSchema: GenMessage<WeeklyRule, {jsonType: WeeklyRuleJson}> = /*@__PURE__*/
  messageDesc(file_container_group, 10);

/**
 * @generated from message raccoonai.MonthlyRule
 */
export type MonthlyRule = Message<"raccoonai.MonthlyRule"> & {
  /**
   * 1-31; a day a month lacks is skipped
   *
   * @generated from field: required uint32 day = 1;
   */
  day: number;

  /**
   * @generated from field: repeated raccoonai.ScheduleWindow windows = 2;
   */
  windows: ScheduleWindow[];
};

/**
 * @generated from message raccoonai.MonthlyRule
 */
export type MonthlyRuleJson = {
  /**
   * 1-31; a day a month lacks is skipped
   *
   * @generated from field: required uint32 day = 1;
   */
  day?: number;

  /**
   * @generated from field: repeated raccoonai.ScheduleWindow windows = 2;
   */
  windows?: ScheduleWindowJson[];
};

/**
 * Describes the message raccoonai.MonthlyRule.
 * Use `create(MonthlyRuleSchema)` to create a new message.
 */
export const MonthlyRuleSchema: GenMessage<MonthlyRule, {jsonType: MonthlyRuleJson}> = /*@__PURE__*/
  messageDesc(file_container_group, 11);

/**
 * @generated from message raccoonai.EveryNDaysRule
 */
export type EveryNDaysRule = Message<"raccoonai.EveryNDaysRule"> & {
  /**
   * >= 1, counted from valid_from
   *
   * @generated from field: required uint32 n = 1;
   */
  n: number;

  /**
   * @generated from field: repeated raccoonai.ScheduleWindow windows = 2;
   */
  windows: ScheduleWindow[];
};

/**
 * @generated from message raccoonai.EveryNDaysRule
 */
export type EveryNDaysRuleJson = {
  /**
   * >= 1, counted from valid_from
   *
   * @generated from field: required uint32 n = 1;
   */
  n?: number;

  /**
   * @generated from field: repeated raccoonai.ScheduleWindow windows = 2;
   */
  windows?: ScheduleWindowJson[];
};

/**
 * Describes the message raccoonai.EveryNDaysRule.
 * Use `create(EveryNDaysRuleSchema)` to create a new message.
 */
export const EveryNDaysRuleSchema: GenMessage<EveryNDaysRule, {jsonType: EveryNDaysRuleJson}> = /*@__PURE__*/
  messageDesc(file_container_group, 12);

/**
 * @generated from message raccoonai.WeeklyRules
 */
export type WeeklyRules = Message<"raccoonai.WeeklyRules"> & {
  /**
   * @generated from field: repeated raccoonai.WeeklyRule days = 1;
   */
  days: WeeklyRule[];

  /**
   * 1-12; empty = every month
   *
   * @generated from field: repeated uint32 months = 2;
   */
  months: number[];
};

/**
 * @generated from message raccoonai.WeeklyRules
 */
export type WeeklyRulesJson = {
  /**
   * @generated from field: repeated raccoonai.WeeklyRule days = 1;
   */
  days?: WeeklyRuleJson[];

  /**
   * 1-12; empty = every month
   *
   * @generated from field: repeated uint32 months = 2;
   */
  months?: number[];
};

/**
 * Describes the message raccoonai.WeeklyRules.
 * Use `create(WeeklyRulesSchema)` to create a new message.
 */
export const WeeklyRulesSchema: GenMessage<WeeklyRules, {jsonType: WeeklyRulesJson}> = /*@__PURE__*/
  messageDesc(file_container_group, 13);

/**
 * @generated from message raccoonai.MonthlyRules
 */
export type MonthlyRules = Message<"raccoonai.MonthlyRules"> & {
  /**
   * @generated from field: repeated raccoonai.MonthlyRule days = 1;
   */
  days: MonthlyRule[];

  /**
   * 1-12; empty = every month
   *
   * @generated from field: repeated uint32 months = 2;
   */
  months: number[];
};

/**
 * @generated from message raccoonai.MonthlyRules
 */
export type MonthlyRulesJson = {
  /**
   * @generated from field: repeated raccoonai.MonthlyRule days = 1;
   */
  days?: MonthlyRuleJson[];

  /**
   * 1-12; empty = every month
   *
   * @generated from field: repeated uint32 months = 2;
   */
  months?: number[];
};

/**
 * Describes the message raccoonai.MonthlyRules.
 * Use `create(MonthlyRulesSchema)` to create a new message.
 */
export const MonthlyRulesSchema: GenMessage<MonthlyRules, {jsonType: MonthlyRulesJson}> = /*@__PURE__*/
  messageDesc(file_container_group, 14);

/**
 * One kind per schedule; the kind is the schedule's type.
 *
 * @generated from message raccoonai.ScheduleRules
 */
export type ScheduleRules = Message<"raccoonai.ScheduleRules"> & {
  /**
   * @generated from oneof raccoonai.ScheduleRules.rule
   */
  rule: {
    /**
     * @generated from field: raccoonai.WeeklyRules weekly = 1;
     */
    value: WeeklyRules;
    case: "weekly";
  } | {
    /**
     * @generated from field: raccoonai.MonthlyRules monthly = 2;
     */
    value: MonthlyRules;
    case: "monthly";
  } | {
    /**
     * @generated from field: raccoonai.EveryNDaysRule every_n_days = 3 [json_name = "every_n_days"];
     */
    value: EveryNDaysRule;
    case: "everyNDays";
  } | { case: undefined; value?: undefined };
};

/**
 * One kind per schedule; the kind is the schedule's type.
 *
 * @generated from message raccoonai.ScheduleRules
 */
export type ScheduleRulesJson = {
  /**
   * @generated from field: raccoonai.WeeklyRules weekly = 1;
   */
  weekly?: WeeklyRulesJson;

  /**
   * @generated from field: raccoonai.MonthlyRules monthly = 2;
   */
  monthly?: MonthlyRulesJson;

  /**
   * @generated from field: raccoonai.EveryNDaysRule every_n_days = 3 [json_name = "every_n_days"];
   */
  every_n_days?: EveryNDaysRuleJson;
};

/**
 * Describes the message raccoonai.ScheduleRules.
 * Use `create(ScheduleRulesSchema)` to create a new message.
 */
export const ScheduleRulesSchema: GenMessage<ScheduleRules, {jsonType: ScheduleRulesJson}> = /*@__PURE__*/
  messageDesc(file_container_group, 15);

/**
 * @generated from message raccoonai.ContainerGroupSchedule
 */
export type ContainerGroupSchedule = Message<"raccoonai.ContainerGroupSchedule"> & {
  /**
   * @generated from field: required uint64 id = 1;
   */
  id: bigint;

  /**
   * @generated from field: required uint64 container_group_id = 2 [json_name = "container_group_id"];
   */
  containerGroupId: bigint;

  /**
   * @generated from field: required raccoonai.JobType job_type = 3 [json_name = "job_type"];
   */
  jobType: JobType;

  /**
   * unset: the zone's first service provider, then the contract provider
   *
   * @generated from field: optional uint64 service_provider_id = 4 [json_name = "service_provider_id"];
   */
  serviceProviderId: bigint;

  /**
   * @generated from field: optional raccoonai.Organization service_provider = 5 [json_name = "service_provider"];
   */
  serviceProvider?: Organization;

  /**
   * YYYY-MM-DD, Asia/Almaty, inclusive; unset only on legacy rows
   *
   * @generated from field: optional string valid_from = 6 [json_name = "valid_from"];
   */
  validFrom: string;

  /**
   * @generated from field: optional string valid_to = 7 [json_name = "valid_to"];
   */
  validTo: string;

  /**
   * unset on a legacy row
   *
   * @generated from field: optional raccoonai.ScheduleRules rules = 8;
   */
  rules?: ScheduleRules;

  /**
   * a pre-table cron string; read-only, never accepted on writes
   *
   * @generated from field: optional string legacy_expr = 9 [json_name = "legacy_expr"];
   */
  legacyExpr: string;

  /**
   * @generated from field: optional google.protobuf.Timestamp created_at = 101 [json_name = "created_at"];
   */
  createdAt?: Timestamp;

  /**
   * @generated from field: optional google.protobuf.Timestamp updated_at = 102 [json_name = "updated_at"];
   */
  updatedAt?: Timestamp;
};

/**
 * @generated from message raccoonai.ContainerGroupSchedule
 */
export type ContainerGroupScheduleJson = {
  /**
   * @generated from field: required uint64 id = 1;
   */
  id?: string;

  /**
   * @generated from field: required uint64 container_group_id = 2 [json_name = "container_group_id"];
   */
  container_group_id?: string;

  /**
   * @generated from field: required raccoonai.JobType job_type = 3 [json_name = "job_type"];
   */
  job_type?: JobTypeJson;

  /**
   * unset: the zone's first service provider, then the contract provider
   *
   * @generated from field: optional uint64 service_provider_id = 4 [json_name = "service_provider_id"];
   */
  service_provider_id?: string;

  /**
   * @generated from field: optional raccoonai.Organization service_provider = 5 [json_name = "service_provider"];
   */
  service_provider?: OrganizationJson;

  /**
   * YYYY-MM-DD, Asia/Almaty, inclusive; unset only on legacy rows
   *
   * @generated from field: optional string valid_from = 6 [json_name = "valid_from"];
   */
  valid_from?: string;

  /**
   * @generated from field: optional string valid_to = 7 [json_name = "valid_to"];
   */
  valid_to?: string;

  /**
   * unset on a legacy row
   *
   * @generated from field: optional raccoonai.ScheduleRules rules = 8;
   */
  rules?: ScheduleRulesJson;

  /**
   * a pre-table cron string; read-only, never accepted on writes
   *
   * @generated from field: optional string legacy_expr = 9 [json_name = "legacy_expr"];
   */
  legacy_expr?: string;

  /**
   * @generated from field: optional google.protobuf.Timestamp created_at = 101 [json_name = "created_at"];
   */
  created_at?: TimestampJson;

  /**
   * @generated from field: optional google.protobuf.Timestamp updated_at = 102 [json_name = "updated_at"];
   */
  updated_at?: TimestampJson;
};

/**
 * Describes the message raccoonai.ContainerGroupSchedule.
 * Use `create(ContainerGroupScheduleSchema)` to create a new message.
 */
export const ContainerGroupScheduleSchema: GenMessage<ContainerGroupSchedule, {jsonType: ContainerGroupScheduleJson}> = /*@__PURE__*/
  messageDesc(file_container_group, 16);

/**
 * @generated from message raccoonai.ContainerGroupScheduleList
 */
export type ContainerGroupScheduleList = Message<"raccoonai.ContainerGroupScheduleList"> & {
  /**
   * @generated from field: repeated raccoonai.ContainerGroupSchedule schedules = 1;
   */
  schedules: ContainerGroupSchedule[];

  /**
   * @generated from field: optional raccoonai.ListInfo list_info = 2 [json_name = "list_info"];
   */
  listInfo?: ListInfo;
};

/**
 * @generated from message raccoonai.ContainerGroupScheduleList
 */
export type ContainerGroupScheduleListJson = {
  /**
   * @generated from field: repeated raccoonai.ContainerGroupSchedule schedules = 1;
   */
  schedules?: ContainerGroupScheduleJson[];

  /**
   * @generated from field: optional raccoonai.ListInfo list_info = 2 [json_name = "list_info"];
   */
  list_info?: ListInfoJson;
};

/**
 * Describes the message raccoonai.ContainerGroupScheduleList.
 * Use `create(ContainerGroupScheduleListSchema)` to create a new message.
 */
export const ContainerGroupScheduleListSchema: GenMessage<ContainerGroupScheduleList, {jsonType: ContainerGroupScheduleListJson}> = /*@__PURE__*/
  messageDesc(file_container_group, 17);

